import {MessageBox} from 'element-ui';

var SEH_X509_DN_ATTRHEX = {
  '0603550406': 'C',
  '060355040a': 'O',
  '060355040b': 'OU',
  '0603550403': 'CN',
  '0603550405': 'SN',
  '0603550408': 'ST',
  '0603550407': 'L',
  '06092a864886f70d010901': 'E',
};
export default {
  isEmptyOfObject: function(obj) {
    for (var name in obj) {
      return false;
    }
    return true;
  },

  encodeUnicodeFromGbkBytes: function(bs) {
    var res = [];
    for (var i = 0; i < bs.length; i++) {
      res[i] = ('00' + bs[i].toString(16)).slice(-4);
    }
    return '\\u' + res.join('\\u');
  },
  SEH_X509_hex2rdn: function(hRDN) {
    var hType = ASN1HEX.getDecendantHexTLVByNthList(hRDN, 0, [0, 0]);
    var hValue = ASN1HEX.getDecendantHexVByNthList(hRDN, 0, [0, 1]);
    var type = '';
    try { type = SEH_X509_DN_ATTRHEX[hType]; } catch (ex) { type = hType; }
    hValue = hValue.replace(/(..)/g, '%$1');
    var value = decodeURIComponent(hValue);
    return type + '=' + value;
  },

  SEH_X509_hex2dn: function(hDN) {
    var s = '';
    var a = ASN1HEX.getPosArrayOfChildren_AtObj(hDN, 0);
    for (var i = 0; i < a.length; i++) {
      var hRDN = ASN1HEX.getHexOfTLV_AtObj(hDN, a[i]);
      s = s + '/' + shcaUtils.SEH_X509_hex2rdn(hRDN);
    }
    return s;
  }, arrayBytes2Hex: function(arrBytes) {
    var hexs = '';
    for (var i = 0; i < arrBytes.length; i++) {
      var b = arrBytes[i];
      if (b < 0x10) {
        hexs += ('0' + b.toString(16));
      } else {
        hexs += b.toString(16);
      }
    }
    return hexs;
  }, hex2bytes: function(hData) {
    var len = hData.length / 2;
    var b = new Array(len);
    var i = 0, j = 0;
    while (i < len) {
      b[i] = parseInt(hData.substring(j, j + 2), 16);
      i++, j += 2;
    }
    return b;
  }, getB64FromPEMWithHead: function(sPEM, sHead) {
    var s = sPEM;
    if (s.indexOf('-----BEGIN ') == -1) {
      throw 'can\'t find PEM header: ' + sHead;
    }
    if (typeof sHead == 'string' && sHead != '') {
      s = s.replace('-----BEGIN ' + sHead + '-----', '');
      s = s.replace('-----END ' + sHead + '-----', '');
    } else {
      s = s.replace(/-----BEGIN [^-]+-----/, '');
      s = s.replace(/-----END [^-]+-----/, '');
    }
    var sB64 = s.replace(/\s+/g, '');
    return sB64;
  }, getPEMdataWithHead: function(b64, head) {
    var k = b64.replace(/(.{64})/g, '$1\r\n');
    var val = '-----BEGIN ' + head + '-----\r\n';
    val += k;
    val += '\r\n-----END ' + head + '-----\r\n';
    return val;
  }, hex2str: function(hex) {
    var hValue = hex.replace(/(..)/g, '%$1');
    var value = decodeURIComponent(hValue);
    return value;
//    var arr = hex.split("");
//    var out = "";
//    for (var i = 0; i < arr.length / 2; i++) {
//        var tmp = "0x" + arr[i * 2] + arr[i * 2 + 1];
//        var charValue = String.fromCharCode(tmp);
//        out += charValue;
//    }
//    return out;
  }, str2UTF8: function(str) {
    var codes = '';
    var chkCodes = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789abcdefghijklmnopqrstuvwxyz-_.!~*\'()';
    for (var i = 0; i < str.length; i++) {
      if (chkCodes.indexOf(str[i]) > 0) {
        codes += ((str[i].charCodeAt()).toString(16));
      } else {
        codes += str[i];
      }
    }
    var strUtf8 = encodeURIComponent(codes).replace(/%/g, '');
    return strUtf8;
  }, forgetZero: function(str) {
    var c = str.charCodeAt(str.length - 1);
    var o = '';
    var i = 0;
    if (c == 0) {
      for (i = 0; i < str.length - 1; i++) {
        o = o + String.fromCharCode(str.charCodeAt(i));
      }
    } else {
      o = str;
    }
    return o;
  }, alert: function(obj) {
    MessageBox.alert(obj.Text, '提示', {dangerouslyUseHTMLString: true});
  },
};




//////////////////
// WEBPACK FOOTER
// ./static/lib/js/shcaUtils.js
// module id = J9ex
// module chunks = 3